import { useEffect, useState } from "react";
import { makeStyles } from "tss-react/mui";
import { MiActions, MiInternalDrawer, MiTab } from "@miplatform/components";
import { Box } from "@mui/material";
import { AddArea } from "./AddArea/AddArea";
import { AddAreaTemplate } from "./AddAreaTemplate/AddAreaTemplate";

const tabs = [
  { label: "Empty Areas", value: "emptyAreas", sx: { width: "50%" } },
  { label: "Area Templates", value: "areaTemplates", sx: { width: "50%" } },
];

export function AreaDrawer({
  open = false,
  showTabs = true,
  onClose,
  planAreas,
  areaData,
  areaTemplates,
  selectedAreaTemplate,
  setSelectedAreaTemplate,
  setAreaData,
  selectedFloor,
  setApplyingAreaTemplate,
  actions,
}) {
  const { classes } = useStyles();
  const [activeTab, setActiveTab] = useState("emptyAreas");

  useEffect(() => {
    if (!open) {
      setActiveTab("emptyAreas");
    }
  }, [open]);

  const isTabEmptyAreas = activeTab === "emptyAreas";
  const isTabAreaTemplates = activeTab === "areaTemplates";

  const handleActiveTab = (tab) => {
    setActiveTab(tab);
    setAreaData([]);
    setSelectedAreaTemplate(null);
    setApplyingAreaTemplate(tab === "areaTemplates");
  };

  return (
    <MiInternalDrawer
      removeHeaderMargin
      open={open}
      onClose={() => {
        onClose();
        setActiveTab("emptyAreas");
      }}
      title="Add Areas"
    >
      <Box className={classes.root}>
        {showTabs && (
          <MiTab
            tabs={tabs}
            currentTab={activeTab}
            onTabChange={handleActiveTab}
            scrollButtons={false}
            borderBottom
          />
        )}
        {isTabEmptyAreas && (
          <AddArea
            open={open}
            planAreas={planAreas}
            areaData={areaData}
            setAreaData={setAreaData}
            selectedFloor={selectedFloor}
          />
        )}
        {isTabAreaTemplates && (
          <AddAreaTemplate
            areaTemplates={areaTemplates}
            selectedAreaTemplate={selectedAreaTemplate}
            setSelectedAreaTemplate={setSelectedAreaTemplate}
          />
        )}
        <Box className={classes.actions}>
          <MiActions actions={actions[activeTab]} />
        </Box>
      </Box>
    </MiInternalDrawer>
  );
}

const useStyles = makeStyles()((theme) => ({
  root: {
    width: "100%",
    padding: theme.spacing(0, 0),
    display: "flex",
    flexDirection: "column",
  },
  filterList: {
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  actions: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: theme.spacing(4, 0),
  },
}));
